import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";
import { AppProviders } from "@/app/providers/AppProviders";
import { queryClient } from "@/lib/query/queryClient";
import { registerDevRefresh } from "@/lib/utils/devRefresh";
import "@/styles/globals.css";
import "leaflet/dist/leaflet.css";

// Regjistron window.__refreshApp() vetem ne zhvillim
if (import.meta.env.DEV) registerDevRefresh(queryClient);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);
